import { render, staticRenderFns } from "./timestamp.vue?vue&type=template&id=8f18f922"
import script from "./timestamp.vue?vue&type=script&lang=js"
export * from "./timestamp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports